import { render, staticRenderFns } from "./HistoryReport.vue?vue&type=template&id=79a298c1"
import script from "./HistoryReport.vue?vue&type=script&lang=js"
export * from "./HistoryReport.vue?vue&type=script&lang=js"
import style0 from "./HistoryReport.vue?vue&type=style&index=0&id=79a298c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports